import { ImageAttributionSaveModel } from "client/Api/common";

export type Coordinate = {
	x: number;
	y: number;
};

export type Rect = {
	left: number;
	top: number;
	right: number;
	bottom: number;
};

export enum SelectMode {
	Disabled = 0,
	Manual = 1,
	FromLongTouch = 2
}

export type TextReplacement<TReplacement> = {
	what: string;
	filler: TReplacement;
};

export type StringTextReplacement = TextReplacement<string>;

export type FormattedTextString = {
	template: string;
	replacements: readonly StringTextReplacement[];
};


// keyCode property of keyboard event is deprecated
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
// It's suggested to use key instead, but it's not supported by IE
// So for now it's better to check both properties
export const enum KeyCode {
	Backspace = 8,
	Tab = 9,
	Enter = 13,
	Left = 37,
	Up = 38,
	Right = 39,
	Down = 40,
	Delete = 46,
	Escape = 27,
	PageUp = 33,
	PageDown = 34,
	Home = 36,
	End = 35
};

export const enum Key {
	ArrowLeft = "ArrowLeft",
	ArrowRight = "ArrowRight",
	Enter = "Enter",
	ArrowUp = "ArrowUp",
	ArrowDown = "ArrowDown",
	Delete = "Delete",
	Escape = "Escape",
	ScrollLock = "ScrollLock",
	ContextMenu = "ContextMenu",
	PageUp = "PageUp",
	PageDown = "PageDown",
	Home = "Home",
	End = "End",
	Tab = "Tab",
	Backspace = "Backspace",
	Space = " "
}

export type WeekMode = "culture" | "iso";

export type CalendarStylesColor =
	| "calendar-1"
	| "calendar-2"
	| "calendar-3"
	| "calendar-4"
	| "calendar-5"
	| "calendar-6"
	| "calendar-7"
	| "calendar-8"
	| "calendar-9"
	| "calendar-10"
	| "calendar-11"
	| "calendar-12"
	| "calendar-13"
	| "calendar-14"
	| "calendar-15"
	| "calendar-16";

export type FileMetadataModel = {
	size: number;
	mimeType: string;
};

export const fileMetadataSymbol = Symbol();

export type Base64FileUriUploadWithMetadataModel = Base64FileUriUploadModel & {
	[fileMetadataSymbol]: FileMetadataModel;
};

export type Base64FileUriUploadWithMetadataAndAttributionModel = Base64FileUriUploadWithMetadataModel & {
	attribution: ImageAttributionSaveModel | null;
};